import React from "react";
import { useForm } from "react-hook-form";
import Button from "@material-ui/core/Button";
import { CircularProgress } from "@material-ui/core";
import { useMutation } from "@apollo/client";
import { RESET_PASS } from "../../Graghql/mutations";
import { toggleSnackbar } from "../../RactiveVariables/index";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

const ResetPassword = (props) => {
  const history=useHistory()
  const { id } = useParams();
  const [resetPassword, { loading: resetLoading }] = useMutation(RESET_PASS);
  const schema = yup.object().shape({
    newPassword: yup.string().required("New Password is required").matches(/^(?=.*[0-9])(?=.*[!@#$%^&*_])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*_]{8,20}$/, 'Password must be 8 to 20 characters long and should contain at least one uppercase(A-Z),one lowercase(a-z), one number and one special character(!,@,#,$,%,^,&,*,_)'),
    confirmNewPassword: yup
      .string()
      .required("Confirm Password is required")
      .oneOf(
        [yup.ref("newPassword"), null],
        "New Password and Confirm Password do not match"
      ),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    try {
      resetPassword({
        variables: { resetLink: id, newPassword: data.newPassword },
      })
        .then((res) => {
          const message = res?.data?.resetPassword?.message;
          toggleSnackbar({
            status: true,
            message: message,
            variant: "success",
          });
          history.push("/login")
        })
        .catch((err) => {
          const message = err && err.message;
          toggleSnackbar({
            status: true,
            message: message,
            variant: "error",
          });
        });
    } catch (err) {
      const message = err && err.message;
      toggleSnackbar({
        status: true,
        message: message,
        variant: "error",
      });
    }
  };

  return (
    <div className="login-register-wrap page-wrap-height">
      <div className="login-register">
        <img
          src="../assets/images/logo.svg"
          className="login-logo img-fluid d-block m-auto"
          alt="logo"
        />
        <div className="login-register-tab">
          <Link to="#" className="active">RESET PASSWORD</Link>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label className="form-label">
              New Password<sup>*</sup>
            </label>
            <input
              type="password"
              className="form-control"
              {...register("newPassword")}
            />
            {errors.newPassword && (
              <span className="error-msg">{errors?.newPassword?.message}</span>
            )}
          </div>
          <div className="form-group">
            <label className="form-label">
              Confirm New Password<sup>*</sup>
            </label>
            <input
              type="password"
              className="form-control"
              {...register("confirmNewPassword")}
            />
            {errors.confirmNewPassword && (
              <span className="error-msg">
                {errors?.confirmNewPassword?.message}
              </span>
            )}
          </div>
          <div>
            <Button
              disabled={resetLoading}
              className="login-sumbit-btn"
              type="submit"
              color="primary"
            >
              {resetLoading ? <CircularProgress color="secondary" /> : "SUBMIT"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
